import { useDarkMode } from "../../../context/ThemeContext";
import { getThemeClasses } from "../../../utils/ThemeClasses";

export type TemperatureScale = "celsius" | "fahrenheit";

interface ReportTemperatureScaleToggleProps {
  value: TemperatureScale;
  onChange: (value: TemperatureScale) => void;
}

const OPTIONS: { value: TemperatureScale; symbol: string; label: string }[] = [
  { value: "celsius", symbol: "°C", label: "Celsius" },
  { value: "fahrenheit", symbol: "°F", label: "Fahrenheit" },
];

export default function ReportTemperatureScaleToggle({ value, onChange }: ReportTemperatureScaleToggleProps) {
  const { isDarkMode } = useDarkMode();
  const themeClasses = getThemeClasses(isDarkMode);
  const inactiveHover = isDarkMode ? "hover:bg-dark-hover" : "hover:bg-gray-100";

  return (
    <div className={`inline-flex rounded-lg border overflow-hidden ${themeClasses.cardBorder}`}>
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            title={opt.label}
            aria-label={opt.label}
            aria-pressed={active}
            className={`flex items-center justify-center w-10 h-10 text-sm font-semibold transition-colors ${
              active
                ? `${themeClasses.buttonBg} text-white`
                : `${themeClasses.inputBg} ${themeClasses.text} ${inactiveHover}`
            }`}
          >
            {opt.symbol}
          </button>
        );
      })}
    </div>
  );
}
